export default __webpack_public_path__ + "static/media/water2.51fe904e.jpg";